var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.396,
    viewBox: "0 0 20 19.396",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M31.7,6.4,34.023,1.6,36.35,6.4a1.215,1.215,0,0,0,.913.671l5.206.769-3.781,3.743a1.2,1.2,0,0,0-.341,1.065l.89,5.285L34.6,15.447a1.223,1.223,0,0,0-1.144,0l-4.645,2.482.89-5.285a1.219,1.219,0,0,0-.341-1.065L25.578,7.835l5.206-.769A1.207,1.207,0,0,0,31.7,6.4Zm7.517,12.893a.9.9,0,0,0,.959-.064.918.918,0,0,0,.368-.89l-1-5.892,4.213-4.175a.91.91,0,0,0-.508-1.546l-5.808-.856L34.842.511a.91.91,0,0,0-1.637,0l-2.6,5.354-5.8.86a.9.9,0,0,0-.731.618.913.913,0,0,0,.224.928L28.5,12.443l-.993,5.892a.911.911,0,0,0,1.326.955l5.191-2.773,5.191,2.773Z",
    transform: "translate(-24.026)",
    fill: "#0d47a1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star.bf7a1bac9b28eda50c4000ac8f6d99f5.svg";